export default __webpack_public_path__ + "eye-with-a-diagonal-line-interface-symbol-for-invisibility.png";